module.exports = SharedDependencies.React['application-83abc821'];